/**
 * Lecture des claims d'un JWT côté navigateur.
 *
 * Le jeton n'est pas vérifié ici : sa signature ne peut l'être que par l'API.
 * Ces informations ne servent donc qu'à l'affichage — masquer un lien, éviter
 * d'ouvrir une page inutile. Toute donnée sensible reste protégée par l'API,
 * qui valide le jeton à chaque appel.
 */
function decodePayload(token) {
    if (!token) {
        return null;
    }

    try {
        const segment = token.split('.')[1];
        if (!segment) {
            return null;
        }

        // base64url -> base64, en rétablissant le bourrage que le JWT omet.
        const base64 = segment.replace(/-/g, '+').replace(/_/g, '/');
        const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');

        return JSON.parse(atob(padded));
    } catch (error) {
        // Jeton illisible ou tronqué : on le traite comme absent de droits.
        return null;
    }
}

export function getRolesFromToken(token) {
    const payload = decodePayload(token);

    return Array.isArray(payload?.roles) ? payload.roles : [];
}

export function hasRole(token, role) {
    return getRolesFromToken(token).includes(role);
}

export const ROLE_SUPER_ADMIN = 'ROLE_SUPER_ADMIN';
